module.exports = __webpack_public_path__ + "img/bug.7fd37b45.png";